import types from './types';

export const changeTheme = (theme) => ({
  type: types.CHANGE_THEME,
  theme,
});

export const addTodo = (todo) => ({
  type: types.ADD_TODO,
  todo,
});

// ログイン情報設定
export const doLogin = (loginInfo) => ({
  type: types.DO_LOGIN,
  loginInfo,
});

// ログアウト
export const doLogout = () => ({
  type: types.DO_LOGOUT,
});

// パスワードリセット(認証コード送付)
export const sendAuthenticationCode = (sendAuthenticationCodeInfo) => ({
  type: types.SEND_AUTHENTICATION_CODE,
  sendAuthenticationCodeInfo,
});

// パスワードリセット(パスワード更新)
export const doPasswordReset = (passwordResetInfo) => ({
  type: types.DO_PASSWORD_RESET,
  passwordResetInfo,
});

// パスワード変更
export const doPasswordChange = (passwordChangeInfo) => ({
  type: types.DO_PASSWORD_CHANGE,
  passwordChangeInfo,
});

// ユーザー情報取得
export const getUserInfo = (userInfo) => ({
  type: types.GET_USER_INFO,
  userInfo,
});

// メニュー項目
export const setMenuItems = (menuItems) => ({
  type: types.MENU_ITEMS,
  menuItems,
});

// メニュー項目開閉状態
export const expandedMenuItems = (expandedMenuItems) => ({
  type: types.EXPANDED_MENU_ITEMS,
  expandedMenuItems,
});

export default {
  changeTheme,
  addTodo,
  doLogin,
  doLogout,
  doPasswordReset,
  sendAuthenticationCode,
  getUserInfo,
  doPasswordChange,
  setMenuItems,
  expandedMenuItems,
};
